export const PARAMETERS = 'parameters';
export const STATUS = 'status';
export const IS_ACTIVE = 'isActive'; //DIST026

export const DIST026_TREATMENT_KEY = 'dist-026';
export const DIST026_GROUP_PARAMETER_KEY = 'group';
export const DIST026_STATUS_PARAMETER_KEY = 'status';
export const DIST026_IS_ACTIVE_KEY = 'isActive';
export let DIST026_GROUP_PARAMETER_OPTIONS; // TX0120

(function (DIST026_GROUP_PARAMETER_OPTIONS) {
  DIST026_GROUP_PARAMETER_OPTIONS["control"] = "control";
  DIST026_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(DIST026_GROUP_PARAMETER_OPTIONS || (DIST026_GROUP_PARAMETER_OPTIONS = {}));

export const TX0120_TREATMENT_KEY = 'tx-0120';
export const TX0120_GROUP_PARAMETER_KEY = 'group';
export let TX0120_GROUP_PARAMETER_OPTIONS;

(function (TX0120_GROUP_PARAMETER_OPTIONS) {
  TX0120_GROUP_PARAMETER_OPTIONS["control"] = "control";
  TX0120_GROUP_PARAMETER_OPTIONS["variant"] = "variant";
})(TX0120_GROUP_PARAMETER_OPTIONS || (TX0120_GROUP_PARAMETER_OPTIONS = {}));